import React, { useState } from "react";
import { motion } from "framer-motion";
/* 스타일 컴포턴트 */
import {
  Page, Container, Hero, HeroLeft, HeroRight, Kicker, Title, Subtitle, Ctas, PrimaryBtn, PersonBlock, MainImage,
  FeaturesWrap, FeatureGrid, FeatureCard, FeatureIcon, FeatureTitle, FeatureDesc, PartnersSection, PartnersGrid,
  PartnerCard, PLogo, PInfo, Tag, ModalOverlay, ModalContent, CloseButton, Results, ReferenceGrid, ReferenceCard,
  MAIN, fadeUp, slideLeft, slideRight, SectionSubtitle, SectionTitle, TitleH2, FeatureMore,
} from "./../style/IndexPageStyle";
/* 차트 */
import CustomLineChart from "./../Component/ChartComponent"
/* 이미지 */
import Npayimg from "./../images/Npay_img.png";
import Rcoimg from "./../images/Rco_img.png";
import Remindimg from "./../images/Remind_img.png";
import Mainimg from "./../images/Main_img.png";
import eximg_1 from "./../images/eximg_1.png"
import eximg_2 from "./../images/eximg_2.png";
import SKimg from "./../images/SK_logo.png"
import KBiimg from "./../images/KBcard_logo.png"
import CJoneimg from "./../images/CJone_logo.png"
import Lpointimg from "./../images/Lpoint_logo.png"

/* MAIN COMPONENT */
const BiztingLanding = () => {
  const [selectedFeature, setSelectedFeature] = useState(null);

  const features = [
    {
      key: "template",
      icon: "⚡",
      title: "추천 메시지 템플릿",
      desc: "템플릿 검수 과정 없이 누구나 손쉽게 캠페인을 만들 수 있습니다.",
      img: Rcoimg,
      detail:
        "\n기존 정해진 형식에 특정 변수만 바꾸어 보다 더 빠르게 고객에게 메시지를 전할 수 있습니다. ",
    },
    {
      key: "remind",
      icon: "✔",
      title: "리마인드 & 문구 불러오기",
      desc: "미반응 고객에게 리마인드 및 문구불러오기로 더 많은 반응을 유도해 보세요.",
      img: Remindimg,
      detail: (
        <>
          <p>
            <strong>문구 불러오기:</strong> '문구 불러오기' 선택 시, 이전에 발송했던 문구를 복사하여 쉽게 수정하실 수 있습니다.
          </p>
          <p>
            <strong>리마인드:</strong> 이전 캠페인 내용을 불러와 특별 검수 과정 없이 같은 내용으로 문자 재발송을 도와줍니다.
          </p>
        </>
      ),
    },
    {
      key: "npoint",
      icon: "ⓒ",
      title: "N PAY 적립",
      desc: "Npay 적립을 통해 고객의 참여율을 보다 더 높힐 수 있습니다. ",
      img: Npayimg,
      detail: "\n메시지 수신자 or 반응자에게 '네이버 페이' 랜덤 지급이 가능합니다.\n\n*포인트 지급은 SKT 타겟팅 툴 사용 시 SKT에서 부담",
    },
  ];

  const partners = [
    {
      key: "skt",
      title: "SKT",
      logo: SKimg,
      desc: (
        <>
          <strong style={{ color: "red", fontWeight: "700" }}>+1,700만</strong> 마케팅 수신동의 회원
        </>
      ),
      tags: ["#앱/웹 접속 이력", "#행동 기반 타겟팅", "#전화 발신 이력", "#위치/이동 이력"],
    },
    {
      key: "kb",
      title: "KB 국민카드",
      logo: KBiimg,
      desc: (
        <>
          <strong style={{ color: "red", fontWeight: "700" }}>+1,400만</strong> 마케팅 수신동의 회원
        </>
      ),
      tags: ["#카드 결제 이력", "#브랜드 결제 이력", "#상품 결제 이력", "#관심 스토어"],
    },
    {
      key: "cj",
      title: "CJ ONE",
      logo: CJoneimg,
      desc: (
        <>
          <strong style={{ color: "red", fontWeight: "700" }}>+1,400만</strong> 마케팅 수신동의 회원
        </>
      ),
      tags: ["#관심사", "#소비 정보", "#구매이력"],
    },
    {
      key: "l",
      title: "L.point",
      logo: Lpointimg,
      desc: (
        <>
          <strong style={{ color: "red", fontWeight: "700" }}>+1,100만</strong> 마케팅 수신동의 회원
        </>
      ),
      tags: ["#관심사", "#소비 정보", "#구매이력"],
    },
  ];

  const responseData = [
    {
      img: eximg_1,
      type: "상품 할인 이벤트 n차 발송 반응률 추이",
      category: "상품",
      target: "앱·웹 > 쇼핑",
      message: "온라인 상품 할인 안내",
      first: 5.4,
      second: 6.04,
      third: 7.19,
    },
    {
      img: eximg_2,
      type: "상품 할인 행사 n차 발송 반응률 추이",
      category: "상품",
      target: "위치·이동특성",
      message: "오프라인 할인 행사 안내",
      first: 17.9,
      second: 10.21,
      third: 13.4,
    },
  ];
  return (
    <Page>
      <Container>
        {/* HERO */}
        <Hero>
          <HeroLeft>
            <Kicker>더 많은 고객에게,<br />더 관심 있는 고객에게</Kicker>
            <Title>
              넓은 메시지 확산,{" "}
              <span style={{ color: MAIN.mint }}>정확한 메시지 도달</span>
            </Title>
            <Subtitle>꼭 우리 회사의 고객이 아니어도 괜찮아요.</Subtitle>
            <Subtitle>
              통신사·카드사·포인트사 데이터를 활용해 관심 있는 잠재 고객에게 메시지를 전달하세요.
            </Subtitle>
            <Ctas>
              <motion.div
                initial="hidden"
                whileInView="show"
                variants={fadeUp}
                viewport={{ once: true }}
              >
                <PrimaryBtn
                  onClick={() =>
                    window.open("https://forms.gle/PggSaZ8pHgerrUo36", "_blank")
                  }
                >
                  서비스 문의하기
                </PrimaryBtn>
              </motion.div>
            </Ctas>
          </HeroLeft>
          <HeroRight>
            <PersonBlock
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <MainImage src={Mainimg} alt="메인 이미지" />
            </PersonBlock>
          </HeroRight>
        </Hero>
      </Container>

      {/* FEATURES */}
      <Container>
        <FeaturesWrap>
          <SectionTitle>
            효과적인 마케팅을 위한<span style={{ color: MAIN.mint }}> 비즈팅</span>만의 특별 기능!
          </SectionTitle>
          <SectionSubtitle>
            1차 발송으로 반응 좋은 고객과 신규 고객의 모수를 추출하고, 이를 기반으로<span style={{ color: "red", fontWeight: "550" }}>  2·3차 리타게팅</span>까지 노려보세요!
          </SectionSubtitle>
          <FeatureGrid>
            {features.map((f, i) => (
              <FeatureCard
                key={f.key}
                initial="hidden"
                whileInView="show"
                variants={fadeUp}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                onClick={() => setSelectedFeature(f)}
                style={{ cursor: "pointer" }}
              >
                <FeatureIcon>{f.icon}</FeatureIcon>
                <FeatureTitle>{f.title}</FeatureTitle>
                <FeatureDesc>{f.desc}</FeatureDesc>
                <FeatureMore>자세히 보기 →</FeatureMore>
              </FeatureCard>
            ))}
          </FeatureGrid>
          {selectedFeature && (
            <ModalOverlay onClick={() => setSelectedFeature(null)}>
              <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={() => setSelectedFeature(null)}>×</CloseButton>
                <img src={selectedFeature.img} alt={selectedFeature.title} />
                <div className="textContent">
                  <h3>{selectedFeature.title}</h3>
                  <p>{selectedFeature.detail}</p>
                </div>
              </ModalContent>
            </ModalOverlay>
          )}
        </FeaturesWrap>
      </Container>

      {/* PARTNERS */}
      <PartnersSection>
        <Container>
          <motion.div
            initial="hidden"
            whileInView="show"
            variants={slideLeft}
            viewport={{ once: true }}
          >
            <TitleH2>비즈팅 제휴사</TitleH2>
          </motion.div>
          <PartnersGrid>
            {partners.map((p, i) => (
              <PartnerCard
                key={p.key}
                initial="hidden"
                whileInView="show"
                variants={slideRight}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
              >
                <PLogo>
                  <img src={p.logo} alt={p.title} />
                </PLogo>

                <PInfo>
                  <h4>{p.title}</h4>
                  <p>{p.desc}</p>
                  <div className="tags">
                    {p.tags.map((tag, index) => (
                      <Tag key={index}>{tag}</Tag>
                    ))}
                  </div>
                </PInfo>
              </PartnerCard>
            ))}
          </PartnersGrid>
          <p
            style={{
              marginTop: "1.5rem",
              fontSize: "0.95rem",
              color: "red",
              textAlign: "center",
              lineHeight: "1.4",
            }}
          >
            * SKT 외 다른 제휴사 서비스를 이용하실 고객분들은 별도 문의 부탁드립니다.
          </p>
        </Container>
      </PartnersSection>

      {/* RESULTS */}
      <Container>
        <Results>
          <motion.div
            initial="hidden"
            whileInView="show"
            variants={fadeUp}
            viewport={{ once: true }}
          >
            <SectionTitle>메시지 반응률로 증명된 효과</SectionTitle>
            <SectionSubtitle>
              일반 메시지의 반응률 1%에 비해, 비즈팅 타겟팅 메시지는 1~3차 발송에서 약 10배<br /> 더 높은 반응률을 보이며, N차 발송에도 안정적이고 정밀한 고객 타겟팅이 가능합니다.
            </SectionSubtitle>
          </motion.div>
          <ReferenceGrid>
            {responseData.map((data) => {
              const chartData = [
                { label: "1차", value: data.first }, { label: "2차", value: data.second }, { label: "3차", value: data.third },
              ];
              return (
                <ReferenceCard>
                  {/* LEFT */}
                  <div className="left">
                    <img src={data.img} alt={data.type} />
                  </div>

                  {/* RIGHT */}
                  <div className="right">
                    <h4>{data.type}</h4>
                    <div className="chart-wrap">
                      <CustomLineChart chartData={chartData} />
                    </div>


                    <div className="meta">
                      <div>
                        <strong>카테고리</strong>: {data.category}
                      </div>
                      <div>
                        <strong>타겟팅</strong>: {data.target}
                      </div>
                      <div>
                        <strong>메시지 내용</strong>: {data.message}
                      </div>
                    </div>
                    <div className="average">*반응률은 실제 발송 데이터에 기반하며, 타겟팅 조건에 따라 달라질 수 있습니다.*</div>
                  </div>
                </ReferenceCard>
              );
            })}
          </ReferenceGrid>
                         <motion.div
                initial="hidden"
                whileInView="show"
                variants={fadeUp}
                viewport={{ once: true }}
                  style={{ textAlign: "center", marginTop: "1.5rem" }}
              >
                <PrimaryBtn
                  onClick={() =>
                    window.open("https://forms.gle/PggSaZ8pHgerrUo36", "_blank")
                  }
                >
                  서비스 문의하기
                </PrimaryBtn>
              </motion.div>
        </Results>
      </Container>
    </Page>
  );
};

export default BiztingLanding;